import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { profileSelector } from 'src/store/profile';

import { CustomPagination, SectionCard, WhiteCard } from 'src/components';

import { ProfileInfoIcon } from 'src/assets';
import './accountRequests.scss';

export const AccountRequests = () => {
  const { t } = useTranslation('personalAccount');

  const navigate = useNavigate();

  const profile = useSelector(profileSelector);

  const orders = profile?.orders || [];

  const bodyTitle = {
    PENDING: t('statuses:PENDING'),
    PAID: t('statuses:PAID'),
    COMPLETE: t('statuses:COMPLETE'),
    CANCEL: t('statuses:CANCEL'),
    PARTIAL_PAYMENT: t('statuses:PARTIAL_PAYMENT'),
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const startIndex = (currentPage - 1) * perPage;
  const endIndex = startIndex + perPage;
  const itemsToRender = orders.slice(startIndex, endIndex);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPerPage(pageSize);
  };

  const onClickInfoIcon = useCallback(
    (item) => () => {
      const { token, status } = item;

      if (status === 'PENDING') {
        return navigate(`/exchange/${token}/view`);
      }

      return navigate(`/exchange/${token}/status`);
    },
    [navigate],
  );

  return (
    <div className="account-requests">
      <SectionCard title={t('requests')}>
        <WhiteCard>
          {orders?.length ? (
            <>
              <table className="account-requests__table">
                <thead>
                  <tr>
                    <th>{t('created')}</th>
                    <th>{t('give')}</th>
                    <th>{t('receive')}</th>
                    <th style={{ textAlign: 'right' }}>{t('status')}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {itemsToRender?.map((item) => (
                    <tr key={item.token}>
                      <td>{moment(item.created_at).format('DD.MM.YYYY, HH:mm')}</td>
                      <td>
                        {item?.given_name}, {item?.given_sum} {item?.given_code}
                      </td>
                      <td>
                        {item?.received_name}, {item?.received_sum} {item?.received_code}
                      </td>
                      <td style={{ textAlign: 'right' }}>{bodyTitle?.[item.status]}</td>
                      <td style={{ textAlign: 'right' }}>
                        <img
                          src={ProfileInfoIcon}
                          alt={ProfileInfoIcon}
                          onClick={onClickInfoIcon(item)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <CustomPagination
                totalItems={orders.length}
                initialPage={currentPage}
                initialPerPage={perPage}
                onPageChange={handlePageChange}
                withSelect={false}
              />
            </>
          ) : (
            <div className="account-requests__empty">{t('profile:emptyOrders')}</div>
          )}
        </WhiteCard>
      </SectionCard>
    </div>
  );
};
